
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import VueCropper from 'vue-cropper'
  @Component({ 
    components: {} 
  })
export default class cropper extends Vue {
    @Prop() imgFile: string
    @Prop() isNewPic: string

    previews:any = {} // 预览数据
    option:any = {
      img: '', // 裁剪图片的地址  (默认：空)
      size: 1, // 裁剪生成图片的质量  (默认:1)
      full: true, // 是否输出原图比例的截图 选true生成的图片会非常大  (默认:false)
      outputType: 'png', // 裁剪生成图片的格式  (默认:jpg)
      canMove: true, // 上传图片是否可以移动  (默认:true)
      original: false, // 上传图片按照原始比例渲染  (默认:false)
      canMoveBox: true, // 截图框能否拖动  (默认:true)
      autoCrop: true, // 是否默认生成截图框  (默认:false)
      autoCropWidth: 500, // 默认生成截图框宽度  (默认:80%)
      autoCropHeight: 260, // 默认生成截图框高度  (默认:80%)
      fixedBox: false, // 固定截图框大小 不允许改变  (默认:false)
      fixed: true, // 是否开启截图框宽高固定比例  (默认:true)
      fixedNumber: [25, 13] // 截图框比例  (默认:[1:1])
    }
    downImg: string = '#'

    Update () {
      this.option.img = this.imgFile['url']
    }
    realTime (data) {
      // 实时预览
      this.previews = data
    }
    uploadImg (type) {
      // 将剪裁好的图片回传给父组件
      // event.preventDefault()
      let that = this
      this.$refs.cropper['getCropData'](data => {
        that.$emit('upload', data)
      })
    }

    mounted() {
     this.Update()
    }
}
